<template>
  <div id="yotpo-testimonials-custom-tab">
    <span class="text-xl">Loading...</span>
  </div>
</template>
<script setup lang="ts">
useYotpo()
</script>
